import React from 'react';

import { ILoyaltyTransaction } from '@rbi-ctg/menu';
import { t } from 'state/intl/translations';

import {
  Divider,
  StyledLoyaltyPointsIcon,
  Total,
  TotalLabel,
  TotalsRow,
} from './modal-order-details.styled';

export const OrderRewardDetails = ({
  loyaltyTransaction,
}: {
  loyaltyTransaction: ILoyaltyTransaction;
}) => {
  const { pointsBalance, pointsUsed } = loyaltyTransaction;

  return (
    <>
      {/* Available Points */}
      <TotalsRow>
        <TotalLabel focusable>{t('availablePoints')}</TotalLabel>
        <Total marginRight="$1" focusable>
          {pointsBalance}
        </Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      {/* Redeeming */}
      <TotalsRow marginTop="$2">
        <TotalLabel focusable>{t('redeeming')}</TotalLabel>
        <Total marginRight="$1" focusable>
          {-(pointsUsed || 0)}
        </Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      <Divider />
    </>
  );
};
